const Loader = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      <div className="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-blue-700" />
    </div>
  );
};

export default Loader;
